import { IconType } from "react-icons";
import { IoTrophyOutline } from "react-icons/io5";
import { TiDocumentText } from "react-icons/ti";

export interface WhyItMattersItem {
  icon: IconType;
  title: string;
  description: string;
}

export const whyItMattersData: WhyItMattersItem[] = [
  {
    icon: TiDocumentText,
    title: "Streamlined Compliance",
    description:
      "The program is backed by state regulations, reducing the risk of violations or uncertainty around prize values and redemption rules.",
  },
  {
    icon: IoTrophyOutline,
    title: "Player-Friendly Experience",
    description:
      "Customers enjoy the flexibility of choosing where to spend their rewards. It builds trust and loyalty while increasing repeat business.",
  },
];
